import React, { memo } from "react";
import { Grid } from "@mui/material";
import UpdateSection from "./updateSection/UpdateSection";

interface Props {
  heading?: string;
  name: string;
  bulk?: boolean;
  children: React.ReactNode;
}

const SectionContainer = (props: Props) => {
  const { name, bulk = false, children } = props;

  return (
    <Grid container spacing={2}>
      {bulk && (
        <Grid item xs={12}>
          <UpdateSection name={name} />
        </Grid>
      )}

      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default memo(SectionContainer);
